import { createSlice } from "@reduxjs/toolkit";

const filtersRegistrationSlice = createSlice({
  name: "filterRegistration",
  initialState: {
    filters: {
      sort: {
        column: {
          title: "Datum prijave",
          dataIndex: "createdAt",
          key: "createdAt",
          defaultSortOrder: "descend",
        },
        field: "createdAt",
        columnKey: "createdAt",
        order: "descend",
      },
      filters: {},
    },
  },
  reducers: {
    setFiltersRegistration: (state, action) => {
      state.filters = {
        sort: action.payload.sort,
        filters: action.payload.filters,
      };
    },
    resetFiltersRegistration: (state) => {
      state.filters = {
        sort: {
          column: {
            title: "Datum prijave",
            dataIndex: "createdAt",
            key: "createdAt",
            defaultSortOrder: "descend",
          },
          field: "createdAt",
          columnKey: "createdAt",
          order: "descend",
        },
        filters: {
          firstName: null,
          lastName: null,
          typeOfParticipation: null,
          companyName: null,
          type: null,
          eventXRoomType: null,
          participant: null,
          event: null,
          createdType: null,
          userName: null,
          status: null,
        },
      };
    },
  },
});

export const { setFiltersRegistration, resetFiltersRegistration } =
  filtersRegistrationSlice.actions;
export default filtersRegistrationSlice.reducer;
